import { proxy } from 'valtio'
import { devtools } from 'valtio/utils'

import { login, logout } from '@/api/base'
import * as storage from '@/utils/storage'
import { StoreKey } from '@/constants/index'
import defaultTheme from '@/constants/theme'
import type { IUserInfo } from '@/types/user'
import { chatAction } from './chat'

interface IState {
  userInfo: IUserInfo
  theme: any
}

export const staticState = {
  // 全局音频单例
  currentAudio: null as any,
}

const globalState = proxy<IState>({
  userInfo: storage.getLocal(StoreKey.User) ?? {},
  theme: defaultTheme,
})

if (import.meta.env.DEV) {
  devtools(globalState, { name: 'globalState', enabled: true })
}

const globalActions = {
  login: async (payload: any): Promise<any> => {
    try {
      const { data } = await login(payload)
      storage.setLocal(StoreKey.User, data, null)
      globalState.userInfo = data || {}
      chatAction.createNewSession()
    } catch (error) {
      return await Promise.reject(error)
    }
  },
  logoutWithAuth: async () => {
    await logout()
    globalActions.logout()
  },
  logout: async () => {
    try {
      storage.removeLocal(StoreKey.User)
      globalState.userInfo = {}
      location.hash = '#/login'
    } catch (error) {
      console.log('logout error')
    }
  },
  // getUserInfo: () => {},
  updateTheme: ({ token, algorithm }: any) => {
    globalState.theme = {
      token: {
        ...globalState.theme.token,
        ...token,
      },
      algorithm: algorithm || globalState.theme.algorithm,
    }
  },
  pauseCurrentAudio: (instance?: any) => {
    if (staticState.currentAudio) {
      staticState.currentAudio.pause()
    }
    if (instance) {
      staticState.currentAudio = instance
    } else {
      staticState.currentAudio = null
    }
  },
}

export { globalState, globalActions }
